function TicketsTimeFilter({ activeFilter, setActiveFilter, TIME_FILTERS }) {
  return (
    <div className="flex items-center gap-2">
      <select
        className="bg-aw-bluedark-95 text-white text-sm rounded-2xl px-2 py-1 border border-aw-bluegray focus:outline-none"
        value={activeFilter}
        onChange={(e) => setActiveFilter(e.target.value)}
      >
        {TIME_FILTERS.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
}

export default function TicketsHeader({ onClose, activeFilter, setActiveFilter, TIME_FILTERS }) {
  return (
    <>
      <div className="text-white font-bold text-sm">Mis Tickets</div>
      {/* <TicketsTimeFilter
        activeFilter={activeFilter}
        setActiveFilter={setActiveFilter}
        TIME_FILTERS={TIME_FILTERS}
      /> */}
      <button
        onClick={onClose}
        className="text-white text-xl font-bold hover:text-aw-green"
      >
        &times;
      </button>
    </>
  );
}
